import { render } from "./Home.vue?vue&type=template&id=42522371&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=42522371&lang=scss&scoped=true"

import exportComponent from "/builds/julienanthonyweb/casa-portugal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42522371"]])

export default __exports__